export default {
  width: 40,
  height: 40,
  stroke: false,
  svg: '<path fill-rule="evenodd" clip-rule="evenodd" d="M20 40c11.0457 0 20-8.9543 20-20S31.0457 0 20 0 0 8.9543 0 20s8.9543 20 20 20zm-2-22V8h4v10h10v4H22v10h-4V22H8v-4h10z"/>'
}
